import cn from 'classnames';
import React, {useState} from 'react';

import {ButtonRaw} from '@/components/Button';
import {ExpansionPanelArrowIcon} from '@/components/Icons';
import {twx} from '@/utils/tailwindUtils';

import TermsOfUseDescription from '../../../../TermsOfUseDescription/TermsOfUseDescription';

const ExpansionPanel = ({titleId, title, innerTextId, innerText, children, onTncLinkClick}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const onExpansionPanelClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={cn('relative w-full cursor-pointer select-none rounded-xl bg-primary-dark-5 p-6 md:min-h-18')}>
            <div className={cn('flex items-center justify-between', {'mb-4': isExpanded})}>
                <h2 className='m-0 flex h-full w-full items-center p-0 text-16 font-bold leading-15'>
                    <ButtonRaw
                        className='flex w-full items-center'
                        onClick={onExpansionPanelClick}
                        aria-controls={innerTextId}
                        aria-expanded={isExpanded}
                        aria-label={title}
                        tabIndex={0}
                        role='button'
                    >
                        <ExpansionPanelArrowIcon
                            className={cn('w-3 min-w-[12px] duration-200 ease-in-out', {'rotate-180': isExpanded})}
                            onClick={onExpansionPanelClick}
                        />
                        <span id={titleId} className='w-full px-2 text-start'>
                            {title}
                        </span>
                    </ButtonRaw>
                </h2>
                {children}
            </div>
            {innerText && (
                <TermsOfUseDescription
                    id={innerTextId}
                    className={twx('hidden pb-6 text-start text-16 ml:pl-4', isExpanded && 'block')}
                    innerHtml={innerText}
                    aria-hidden={!isExpanded}
                    onTncLinkClick={onTncLinkClick}
                />
            )}
        </div>
    );
};

export default ExpansionPanel;
